import styled from 'styled-components';

export const SelectorWrapper = styled.div`
  .ant-select {
    min-width: 300px;
    width: 100%;
  }
`;
